import { io } from 'socket.io-client';

// Derive socket URL from the API base URL (strips /api suffix)
// This avoids requiring a separate VITE_SOCKET_URL env var
const getSocketUrl = () => {
  if (import.meta.env.VITE_SOCKET_URL) return import.meta.env.VITE_SOCKET_URL;
  const apiBase = import.meta.env.VITE_API_BASE || import.meta.env.VITE_API_URL || '';
  if (apiBase) return apiBase.replace(/\/api\/?$/, '');
  return 'http://localhost:5001';
};

const socket = io(getSocketUrl(), {
  autoConnect: false,
});

export const connectSocket = (token) => {
  socket.auth = token ? { token } : {};
  if (!socket.connected) {
    socket.connect();
  }
};

export const joinOrderRoom = (orderId, orderToken, cb) => {
  const join = () => {
    socket.emit('joinOrder', { orderId, orderToken }, cb);
  };

  if (socket.connected) {
    join();
    return;
  }

  const handleConnect = () => {
    socket.off('connect', handleConnect);
    join();
  };

  socket.on('connect', handleConnect);

  if (!socket.connected) {
    socket.connect();
  }
};

export default socket;
